import { z } from 'zod'

export const WarningCodeSchema = z.enum([
  'CLIPPING',
  'OVERLAP',
  'EMPTY_ZONE',
  'OUT_OF_BOUNDS',
  'PLACEMENT_OVERFLOW',
  'FONT_SUBSTITUTION',
  'GLYPH_MISSING',
  'TEXT_TRUNCATED',
  'GS1_INVALID_AI',
  'GTIN_CHECKSUM_MISMATCH',
  'SYMBOLOGY_VALIDATION_FAILED',
  'UNBOUND_REQUIRED_FIELD',
  'FIELD_TYPE_MISMATCH',
  'FIRMWARE_QUIRK',
  'PRINT_WIDTH_CLAMPED',
  'LABEL_ROTATED',
  'UNRESOLVED_VARIABLE',
])
export type WarningCode = z.infer<typeof WarningCodeSchema>

export const WarningSeveritySchema = z.enum(['error', 'warn', 'info'])
export type WarningSeverity = z.infer<typeof WarningSeveritySchema>

export const WarningSchema = z.object({
  code: WarningCodeSchema,
  severity: WarningSeveritySchema,
  message: z.string(),
  path: z.array(z.string()).optional(),
  suggestion: z.string().optional(),
})
export type Warning = z.infer<typeof WarningSchema>
